import React from 'react';
import {styled} from '@core-ui/react-stitch';
import universal from '@core-ui/universal';
import useSortBy from '../../hooks/useSortBy';
import useSortByRatings from '../../hooks/features/useSortByRatings';

const SortBy = universal(import('@cat/sort-by'));
const SizeModelToggle = universal(import('@cat/size-model-toggle'));

const ProductOptionsContainer = styled.div(() => ({
  margin: '0 0.5rem',
  width: '100%',
  alignSelf: 'flex-end',
  display: 'flex',
  flex: '1 1 auto',
  justifyContent: 'flex-end',
  '.sort-by-price-dropdown': {
    width: 'auto',
    marginLeft: '1rem',
  },
}));

const ProductOptions = props => {
  const {
    brand,
    publish,
    isModelToggleEnabled,
    isMixedGridEnabled,
  } = props;

  const {value, onChange} = useSortBy();

  const isSortByRatingsEnabled = useSortByRatings();

  return (
    <ProductOptionsContainer>
      {isModelToggleEnabled && (
        <SizeModelToggle
          isMixedGridEnabled={isMixedGridEnabled}
          brand={brand}
          publish={publish}
        />
      )}
      <SortBy value={value} onChange={onChange} isSortByRatingsEnabled={isSortByRatingsEnabled} />
    </ProductOptionsContainer>
  );
};

export {ProductOptions};
